// extracted by mini-css-extract-plugin
module.exports = {"container":"sign_up_ask_phone-module__container--1gAaS"};